import { connect } from "react-redux";
import { connect as formikConnect } from "formik";
import { isCompanyPage as isCompanyPageSelector } from "selectors/location";

import Description from "./Description";

const mapStateToProps = (state) => ({
  isCompanyPage: isCompanyPageSelector(state),
});

export default connect(mapStateToProps)(formikConnect(Description));
